import { ActionIcon, Tooltip } from '@mantine/core'

import { NotificationType } from 'src/graphql/types/notifications'
import IconCheckmarkCircle from 'src/icons/IconCheckmarkCircle'
import IconMessage from 'src/icons/IconMessage'
import IconNavigate from 'src/icons/IconNavigate'

interface NotificationActionsProps {
  isRead: boolean
  notificationType: string
  onMarkAsRead: () => void
  onReply?: () => void
  onView?: () => void
}

const NotificationActions = ({
  isRead,
  notificationType,
  onMarkAsRead,
  onReply,
  onView,
}: NotificationActionsProps) => {
  const isSMS = notificationType === NotificationType.SMS

  return (
    <div className="absolute right-2 top-2 flex flex-row gap-1 rounded-md bg-white p-1 shadow-sm">
      {isSMS && onReply && (
        <Tooltip label="Reply">
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={(e) => {
              e.stopPropagation()
              onReply()
            }}
            className="bg-transparent hover:bg-doubleNickel-gray-100"
          >
            <IconMessage className="h-4 w-4 fill-none stroke-doubleNickel-gray-600" />
          </ActionIcon>
        </Tooltip>
      )}
      {onView && (
        <Tooltip label="View">
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={(e) => {
              e.stopPropagation()
              onView()
            }}
            className="bg-transparent hover:bg-doubleNickel-gray-100"
          >
            <IconNavigate className="h-3.5 w-3.5 fill-none stroke-doubleNickel-gray-600" />
          </ActionIcon>
        </Tooltip>
      )}
      {!isRead && (
        <Tooltip label="Mark as read">
          <ActionIcon
            size="sm"
            variant="subtle"
            onClick={(e) => {
              e.stopPropagation()
              onMarkAsRead()
            }}
            className="bg-transparent hover:bg-doubleNickel-gray-100"
          >
            <IconCheckmarkCircle className="h-4 w-4 fill-none stroke-doubleNickel-gray-600" />
          </ActionIcon>
        </Tooltip>
      )}
    </div>
  )
}

export default NotificationActions
